export const EINGANGSRECHNUNG = 'eingangsrechnung';
export const MESSMITTEL = 'messmittel';
export const WERKZEUG = 'werkzeug';
export const PROZESSKONTROLLKARTE = 'prozesskontrollkarte';
export const WARENEINGANGSPRUEFUNG = 'wareneingangspruefung';
